<div class="tw-p-4 md:tw-p-8">
  <div class="tw-flex tw-gap-2 tw-flex-wrap tw-items-center tw-mb-6">
    <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-my-0">
      Team Management
    </h1>

    <!-- Seat usage (only when the plan has a finite member cap) -->
    <span
      *ngIf="hasSeatLimit"
      class="tw-inline-flex tw-items-center tw-gap-1 tw-text-sm tw-font-medium tw-rounded-full tw-px-3 tw-py-1 tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-gray-700 dark:tw-text-gray-200">
      {{ memberCount === null ? '—' : memberCount }} / {{ maxUsers }} seats used
      <span *ngIf="seatsRemaining !== null" class="tw-text-gray-400">
        · {{ seatsRemaining }} remaining
      </span>
    </span>

    <button
      *ngIf="canAdmin"
      mat-raised-button
      color="primary"
      class="button tw-shrink-0 tw-ml-auto"
      [disabled]="atSeatCap"
      [matTooltip]="'Member limit reached. Upgrade to add more.'"
      [matTooltipDisabled]="!atSeatCap"
      (click)="showInviteDialog()">
      <div class="tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-hidden md:tw-block">add</mat-icon>
        Invite Users
      </div>
    </button>
  </div>

  <!-- At the member cap: prompt an upgrade and link to the billing page.
       (Per-seat add-on users will get an action here once that ships.) -->
  <div *ngIf="atSeatCap" class="tw-mb-8">
    <div
      class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-amber-300 dark:tw-border-amber-500/40 tw-bg-amber-50 dark:tw-bg-amber-900/20 tw-p-4 tw-text-sm tw-text-amber-800 dark:tw-text-amber-200">
      <span>
        You've reached your plan's limit of {{ maxUsers }} team members. Upgrade your plan to add
        more.
      </span>
      <a
        (click)="showPlansDialog()"
        class="tw-shrink-0 tw-px-4 tw-py-2 tw-rounded-md tw-text-sm tw-font-semibold tw-no-underline tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 tw-text-white tw-cursor-pointer">
        View plans
      </a>
    </div>
  </div>

  <div *ngIf="org" id="team-tabs" class="team-tabs">
    <mat-tab-group class="mat-tab-fill-height" mat-stretch-tabs="false">
      <mat-tab label="Users">
        <app-team-users
          [canAdmin]="canAdmin"
          [org]="org"
          (memberCountChange)="onMemberCount($event)"></app-team-users>
      </mat-tab>
      <mat-tab label="Invitations">
        <ng-template matTabContent>
          <app-team-invitations [canAdmin]="canAdmin" [org]="org"></app-team-invitations>
        </ng-template>
      </mat-tab>
      <mat-tab label="Service Accounts">
        <ng-template matTabContent>
          <app-team-service-accounts [canAdmin]="canAdmin" [org]="org"></app-team-service-accounts>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
